export enum IncomeType {
    STATE_PENSION = 'statePension',
    OTHER = 'otherIncome',
    FINAL_SALARY = 'finalSalary',
    ANNUITY = 'annuityIncomePerYear',
    DRAWDOWN = 'drawdownIncomePerYear',
}
export interface ExploreYourOptionsIncome {
    type: IncomeType;
    amount: number;
    startAge?: number;
    endAge?: number;
}
export interface ExploreYourOptionsInputParams {
    potValue: number;
    slContributions: number;
    additionalContributions: number;
    otherPotValue: number;
    otherContributions: number;
    dateOfBirth: string;
    retirementAge: number;
    targetIncome: number;
    statePension?: number;
    finalSalary?: number;
    otherIncome?: number;
    finalSalaryStartAge?: number;
    otherIncomeStartAge?: number;
    tfcPercentage: number;
    drawdownEndAge?: number;
    drawdownIncomePerYear?: number;
    annuityIncomePerYear: number;
}

export interface ExploreYourOptionsPot {
    startAge: number;
    endAge: number | null;
    incomes: ExploreYourOptionsIncome[];
    totalIncome: number;
}

export interface ExploreYourOptionsOutputParams {
    additionalContributions: number;
    additionalPotValue: number;
    annuityCost?: number;
    annuityIncomePerYearMax: number;
    annuityIncomePerYearMin: number;
    annuityPotUsed?: number;
    drawdownEndAge: number;
    drawdownIncomePerYearMax: number;
    drawdownIncomePerYearMin?: number;
    drawdownPotUsed?: number;
    metMyTarget: boolean;
    pots: ExploreYourOptionsPot[];
    potValue: number;
    remainingPotValue?: number;
    retirementAge: number;
    tfcAmount: number;
    tfcPercentage: number;
}

export interface ExploreYourOptionsResponse {
    message: string;
    payload: ExploreYourOptionsOutputParams;
}

export type ExploreOptionsFormValues = {
    additionalContributions: number;
    annuityIncomeAmount: number;
    drawdownEndAge?: number;
    drawdownIncomeAmount?: number;
    retirementAge: number;
    taxFreeCash: number;
};

export type UseOptionsUpdateInput = ExploreOptionsFormValues & {
    isValid: boolean;
};
